import { useAppNavigation } from 'hooks/useAppNavigation';

const BASE_PATH = '/forms-qr';

export const useQRScreenNavigation = () => {
  const { navigateTo } = useAppNavigation();

  return {
    goToVerifyIdentity: () => navigateTo(`${BASE_PATH}/verify-identity`),
    goToVerifyCode: () => navigateTo(`${BASE_PATH}/verify-code`),
    goToInfoCollection: () => navigateTo(`${BASE_PATH}/info-collection`),
    goToGuestUserDetail: () => navigateTo(`${BASE_PATH}/guest-user-detail`),
    goToVariconUserDetail: () => navigateTo(`${BASE_PATH}/varicon-user-detail`),
    goToResponseReceived: () => navigateTo(`${BASE_PATH}/response-received`),
    goToVariconEmployeeDetail: () =>
      navigateTo(`${BASE_PATH}/varicon-employee-detail`),
  };
};
